export function DataTable({ cols, rows }: { cols: readonly string[]; rows: readonly (readonly string[])[] }) {
  return (
    <div className="tablewrap">
      <table className="table">
        <thead><tr>{cols.map((c) => <th key={c}>{c}</th>)}</tr></thead>
        <tbody>
          {rows.map((r, i) => <tr key={i}>{r.map((cell, j) => <td key={j}>{cell}</td>)}</tr>)}
        </tbody>
      </table>
    </div>
  );
}
